"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearManagement = exports.clearManagementModals = exports.addDomainFailure = exports.addDomainSuccess = exports.addDomainRequest = exports.convertUsersFailure = exports.convertUsersSuccess = exports.convertUsersRequest = exports.listUsersFailure = exports.listUsersSuccess = exports.listUsersRequest = exports.toggleCompany = exports.searchCompaniesFailure = exports.searchCompaniesSuccess = exports.searchCompaniesRequest = exports.attachCompanyFailure = exports.attachCompanySuccess = exports.attachCompanyRequest = exports.detachCompanyFailure = exports.detachCompanySuccess = exports.detachCompanyRequest = exports.createNewFederationFailure = exports.createNewFederationSuccess = exports.createNewFederationRequest = exports.fetchManagementCompanyListFailure = exports.fetchManagementCompanyListSuccess = exports.fetchManagementCompanyListRequest = exports.fetchManagementClientListFailure = exports.fetchManagementClientListSuccess = exports.fetchManagementClientListRequest = exports.saveManagementCurrentFailure = exports.saveManagementCurrentSuccess = exports.saveManagementCurrentRequest = exports.updateFieldManagementCurrent = exports.fetchManagementCurrentFailure = exports.fetchManagementCurrentSuccess = exports.fetchManagementCurrentRequest = exports.managementListSelect = exports.managementRemoveFailure = exports.managementRemoveSuccess = exports.managementRemoveRequest = exports.fetchManagementListFailure = exports.fetchManagementListSuccess = exports.fetchManagementListRequest = exports.verifyFailure = exports.verifySuccess = exports.verifyRequest = exports.fetchListFailure = exports.fetchListSuccess = exports.fetchListRequest = void 0;
const ActionTypes = require("../../actionTypes/sso");
function fetchListRequest() {
    return {
        type: ActionTypes.FETCH_LIST_REQUEST
    };
}
exports.fetchListRequest = fetchListRequest;
function fetchListSuccess(list) {
    return {
        type: ActionTypes.FETCH_LIST_SUCCESS,
        payload: list
    };
}
exports.fetchListSuccess = fetchListSuccess;
function fetchListFailure(error) {
    return {
        type: ActionTypes.FETCH_LIST_FAILURE,
        payload: error
    };
}
exports.fetchListFailure = fetchListFailure;
function verifyRequest(provider) {
    return {
        type: ActionTypes.VERIFY_REQUEST,
        payload: provider
    };
}
exports.verifyRequest = verifyRequest;
function verifySuccess(sso) {
    return {
        type: ActionTypes.VERIFY_SUCCESS,
        payload: sso
    };
}
exports.verifySuccess = verifySuccess;
function verifyFailure(error) {
    return {
        type: ActionTypes.VERIFY_FAILURE,
        payload: error
    };
}
exports.verifyFailure = verifyFailure;
// MANAGEMENT
function fetchManagementListRequest() {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_LIST_REQUEST
    };
}
exports.fetchManagementListRequest = fetchManagementListRequest;
function fetchManagementListSuccess(list) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_LIST_SUCCESS,
        payload: list
    };
}
exports.fetchManagementListSuccess = fetchManagementListSuccess;
function fetchManagementListFailure(error) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_LIST_FAILURE,
        payload: error
    };
}
exports.fetchManagementListFailure = fetchManagementListFailure;
function managementRemoveRequest(sso) {
    return {
        type: ActionTypes.MANAGEMENT_REMOVE_REQUEST,
        payload: sso
    };
}
exports.managementRemoveRequest = managementRemoveRequest;
function managementRemoveSuccess() {
    return {
        type: ActionTypes.MANAGEMENT_REMOVE_SUCCESS
    };
}
exports.managementRemoveSuccess = managementRemoveSuccess;
function managementRemoveFailure(error) {
    return {
        type: ActionTypes.MANAGEMENT_REMOVE_FAILURE,
        payload: error
    };
}
exports.managementRemoveFailure = managementRemoveFailure;
function managementListSelect(sso, select) {
    return {
        type: ActionTypes.MANAGEMENT_LIST_SELECT,
        payload: {
            sso,
            select
        }
    };
}
exports.managementListSelect = managementListSelect;
function fetchManagementCurrentRequest(provider) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CURRENT_REQUEST,
        payload: provider
    };
}
exports.fetchManagementCurrentRequest = fetchManagementCurrentRequest;
function fetchManagementCurrentSuccess(sso) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CURRENT_SUCCESS,
        payload: sso
    };
}
exports.fetchManagementCurrentSuccess = fetchManagementCurrentSuccess;
function fetchManagementCurrentFailure(error) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CURRENT_FAILURE,
        payload: error
    };
}
exports.fetchManagementCurrentFailure = fetchManagementCurrentFailure;
function updateFieldManagementCurrent(key, value) {
    return {
        type: ActionTypes.UPDATE_FIELD_MANAGEMENT_CURRENT,
        payload: {
            key,
            value
        }
    };
}
exports.updateFieldManagementCurrent = updateFieldManagementCurrent;
function saveManagementCurrentRequest(provider, data) {
    return {
        type: ActionTypes.SAVE_MANAGEMENT_CURRENT_REQUEST,
        payload: {
            provider,
            data
        }
    };
}
exports.saveManagementCurrentRequest = saveManagementCurrentRequest;
function saveManagementCurrentSuccess(sso) {
    return {
        type: ActionTypes.SAVE_MANAGEMENT_CURRENT_SUCCESS,
        payload: sso
    };
}
exports.saveManagementCurrentSuccess = saveManagementCurrentSuccess;
function saveManagementCurrentFailure(error) {
    return {
        type: ActionTypes.SAVE_MANAGEMENT_CURRENT_FAILURE,
        payload: error
    };
}
exports.saveManagementCurrentFailure = saveManagementCurrentFailure;
function fetchManagementClientListRequest() {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CLIENT_LIST_REQUEST
    };
}
exports.fetchManagementClientListRequest = fetchManagementClientListRequest;
function fetchManagementClientListSuccess(list) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CLIENT_LIST_SUCCESS,
        payload: list
    };
}
exports.fetchManagementClientListSuccess = fetchManagementClientListSuccess;
function fetchManagementClientListFailure(error) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_CLIENT_LIST_FAILURE,
        payload: error
    };
}
exports.fetchManagementClientListFailure = fetchManagementClientListFailure;
function fetchManagementCompanyListRequest(provider) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_COMPANY_LIST_REQUEST,
        payload: provider
    };
}
exports.fetchManagementCompanyListRequest = fetchManagementCompanyListRequest;
function fetchManagementCompanyListSuccess(list) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_COMPANY_LIST_SUCCESS,
        payload: list
    };
}
exports.fetchManagementCompanyListSuccess = fetchManagementCompanyListSuccess;
function fetchManagementCompanyListFailure(error) {
    return {
        type: ActionTypes.FETCH_MANAGEMENT_COMPANY_LIST_FAILURE,
        payload: error
    };
}
exports.fetchManagementCompanyListFailure = fetchManagementCompanyListFailure;
function createNewFederationRequest(sso) {
    return {
        type: ActionTypes.CREATE_NEW_FEDERATION_REQUEST,
        payload: sso
    };
}
exports.createNewFederationRequest = createNewFederationRequest;
function createNewFederationSuccess(sso) {
    return {
        type: ActionTypes.CREATE_NEW_FEDERATION_SUCCESS,
        payload: sso
    };
}
exports.createNewFederationSuccess = createNewFederationSuccess;
function createNewFederationFailure(error) {
    return {
        type: ActionTypes.CREATE_NEW_FEDERATION_FAILURE,
        payload: error
    };
}
exports.createNewFederationFailure = createNewFederationFailure;
function detachCompanyRequest(sso, customer) {
    return {
        type: ActionTypes.DETACH_COMPANY_REQUEST,
        payload: {
            sso,
            customer
        }
    };
}
exports.detachCompanyRequest = detachCompanyRequest;
function detachCompanySuccess() {
    return {
        type: ActionTypes.DETACH_COMPANY_SUCCESS
    };
}
exports.detachCompanySuccess = detachCompanySuccess;
function detachCompanyFailure(error) {
    return {
        type: ActionTypes.DETACH_COMPANY_FAILURE,
        payload: error
    };
}
exports.detachCompanyFailure = detachCompanyFailure;
function attachCompanyRequest(sso, customer) {
    return {
        type: ActionTypes.ATTACH_COMPANY_REQUEST,
        payload: {
            sso,
            customer
        }
    };
}
exports.attachCompanyRequest = attachCompanyRequest;
function attachCompanySuccess() {
    return {
        type: ActionTypes.ATTACH_COMPANY_SUCCESS
    };
}
exports.attachCompanySuccess = attachCompanySuccess;
function attachCompanyFailure(error) {
    return {
        type: ActionTypes.ATTACH_COMPANY_FAILURE,
        payload: error
    };
}
exports.attachCompanyFailure = attachCompanyFailure;
function searchCompaniesRequest(searchString) {
    return {
        type: ActionTypes.SEARCH_COMPANIES_REQUEST,
        payload: searchString
    };
}
exports.searchCompaniesRequest = searchCompaniesRequest;
function searchCompaniesSuccess(customers) {
    return {
        type: ActionTypes.SEARCH_COMPANIES_SUCCESS,
        payload: customers
    };
}
exports.searchCompaniesSuccess = searchCompaniesSuccess;
function searchCompaniesFailure(error) {
    return {
        type: ActionTypes.SEARCH_COMPANIES_FAILURE,
        payload: error
    };
}
exports.searchCompaniesFailure = searchCompaniesFailure;
function toggleCompany(status, customer) {
    return {
        type: ActionTypes.TOGGLE_COMPANY,
        payload: {
            status,
            customer
        }
    };
}
exports.toggleCompany = toggleCompany;
// USERS
function listUsersRequest(sso, filter) {
    return {
        type: ActionTypes.LIST_USERS_REQUEST,
        payload: {
            sso,
            filter
        }
    };
}
exports.listUsersRequest = listUsersRequest;
function listUsersSuccess(users) {
    return {
        type: ActionTypes.LIST_USERS_SUCCESS,
        payload: users
    };
}
exports.listUsersSuccess = listUsersSuccess;
function listUsersFailure(error) {
    return {
        type: ActionTypes.LIST_USERS_FAILURE,
        payload: error
    };
}
exports.listUsersFailure = listUsersFailure;
function convertUsersRequest(sso, users) {
    return {
        type: ActionTypes.CONVERT_USERS_REQUEST,
        payload: {
            sso,
            users
        }
    };
}
exports.convertUsersRequest = convertUsersRequest;
function convertUsersSuccess() {
    return {
        type: ActionTypes.CONVERT_USERS_SUCCESS
    };
}
exports.convertUsersSuccess = convertUsersSuccess;
function convertUsersFailure(error) {
    return {
        type: ActionTypes.CONVERT_USERS_FAILURE,
        payload: error
    };
}
exports.convertUsersFailure = convertUsersFailure;
// Domain
function addDomainRequest(sso, domain) {
    return {
        type: ActionTypes.ADD_DOMAIN_REQUEST,
        payload: {
            sso,
            domain
        }
    };
}
exports.addDomainRequest = addDomainRequest;
function addDomainSuccess() {
    return {
        type: ActionTypes.ADD_DOMAIN_SUCCESS
    };
}
exports.addDomainSuccess = addDomainSuccess;
function addDomainFailure(error) {
    return {
        type: ActionTypes.ADD_DOMAIN_FAILURE,
        payload: error
    };
}
exports.addDomainFailure = addDomainFailure;
// CLEAR
function clearManagementModals() {
    return {
        type: ActionTypes.CLEAR_MANAGEMENT_MODALS
    };
}
exports.clearManagementModals = clearManagementModals;
function clearManagement() {
    return {
        type: ActionTypes.CLEAR_MANAGEMENT
    };
}
exports.clearManagement = clearManagement;
//# sourceMappingURL=index.js.map